const SECTION_SELECTOR = '[data-uc-psp-sticky]';
const VISIBLE_CLASS = 'is-visible';
const FALLBACK_RATIO = 0.9;

const findTrigger = (root) => {
  const hero = document.querySelector('.hero');
  if (hero) return hero;

  const own = root.closest('.shopify-section');
  const sections = Array.from(document.querySelectorAll('#MainContent .shopify-section'));

  return sections.find((section) => section !== own) ?? null;
};

const initSection = (root) => {
  if (root.dataset.ucPspStickyInit) return;
  root.dataset.ucPspStickyInit = '1';

  const setVisible = (visible) => root.classList.toggle(VISIBLE_CLASS, visible);
  const trigger = findTrigger(root);

  if (trigger && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    );

    observer.observe(trigger);
    return;
  }

  let scheduled = false;

  const sync = () => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      setVisible(window.scrollY > window.innerHeight * FALLBACK_RATIO);
    });
  };

  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  sync();
};

const initAll = (scope) => {
  for (const root of scope.querySelectorAll(SECTION_SELECTOR)) {
    initSection(root);
  }
};

initAll(document);

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target);
});
